export default __webpack_public_path__ + "static/media/inpersonate-icon.ae3188ff.svg";